import React, { useState } from "react";
import Slider from "react-slick";
import "./EventCarousel.css";
import { Link } from "react-router-dom";

const EvntFullslider = ({ carouselItems }) => {
  const [highlightedIndex, setHighlightedIndex] = useState(0);

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3, // Default slides to show for larger screens
    slidesToScroll: 1,
    focusOnSelect: true,
    beforeChange: (current, next) =>
      setHighlightedIndex((next + 1) % carouselItems.length), // Highlight second item
    autoplay: true,
    autoplaySpeed: 3000,
    pauseOnHover: true,
    responsive: [
      {
        breakpoint: 1200, // For screens with width <= 1200px
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 991, // For screens with width <= 768px (tablets, small laptops)
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 667, // For screens with width <= 768px (tablets, small laptops)
        settings: {
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 540, // For screens with width <= 480px (mobile devices)
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  return (
    <div className="carousel-container">
      <Slider {...settings}>
        {carouselItems.map((item, index) => (
          <div
            key={item._id}
            className={`carousel-item col-lg-6 col-xl-4 wow fadeInUp ${
              index === highlightedIndex ? "highlighted" : ""
            }`}
          >
            <div className="blog-item">
              <div className="blog-img">
                <img
                  className="img-fluid rounded-top w-100"
                  src={item.imagePath}
                  alt={item.title}
                />
              </div>

              <div className="blog-content rounded-bottom p-4">
                <h4
                  className="d-inline-block truncated-text2 mb-3"
                  style={{ color: "white" }}
                >
                  {item.title}
                </h4>
                <p className="truncated-text">{item.description}</p>

                {/* Corrected Link syntax */}
                <Link
                  to="/detailed-view"
                  state={{
                    title: item.title,
                    description: item.description,
                    imageUrl: item.imagePath,
                  }}
                  className="text-decoration-none"
                >
                  <div className="text-white text-right">
                    <i className="fa fa-angle-right"></i> Read More
                  </div>
                </Link>
              </div>
            </div>
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default EvntFullslider;
